var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackfsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15.88 14.17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: #1e1e1c;\n      }"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.34,14.17C1.66,12.81,0,10.09,0,7.09S1.56,1.56,4.07.15c.14-.08.29-.15.29-.15l.48.94-.25.13c-2.17,1.22-3.53,3.52-3.53,6.01s1.44,4.96,3.76,6.14l-.48.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.54,14.17l-.48-.94c2.32-1.18,3.77-3.54,3.77-6.14s-1.35-4.8-3.53-6.01l-.24-.13L11.55,0l.27.15c2.51,1.41,4.07,4.06,4.07,6.94s-1.67,5.72-4.34,7.08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.56,12.3c-2.04-.93-3.35-2.98-3.35-5.22s1.17-4.08,3.06-5.07c.09-.05.19-.1.29-.14l.44.96-.24.12c-1.54.81-2.5,2.4-2.5,4.14s1.07,3.49,2.73,4.25l-.44.96Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.32,12.31l-.44-.96c1.66-.76,2.74-2.43,2.74-4.26s-.96-3.32-2.5-4.14l-.24-.12.44-.96c.1.05.19.09.28.14,1.89,1,3.06,2.94,3.06,5.08,0,2.24-1.31,4.29-3.35,5.22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.94,10.26c-1.39-.44-2.32-1.71-2.32-3.17,0-1.32.78-2.51,1.99-3.05.11-.05.22-.09.34-.13l.32,1.01-.23.08c-.82.36-1.36,1.17-1.36,2.08,0,.99.64,1.86,1.58,2.16l-.32,1.01Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.94,10.26l-.32-1.01c.95-.3,1.59-1.17,1.59-2.16,0-.9-.53-1.71-1.36-2.08l-.23-.08.33-1.01c.11.04.22.08.33.12,1.21.53,1.99,1.73,1.99,3.05,0,1.46-.93,2.73-2.32,3.17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.75,7.09c0,.44-.36.81-.81.81s-.8-.36-.8-.81.36-.8.8-.8.81.36.81.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackfsc);
export default __webpack_public_path__ + "static/media/blackfsc.5fb3ebd63244b05235f239d6e5d08301.svg";
export { ForwardRef as ReactComponent };